import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import queryString from 'query-string'

import Modal from '../../../components/modal'
import ModalBody from '../../../components/modalBody'
import ModalHeader from '../../../components/modalHeader'

import { translate } from '../../../helpers/stringHelpers'
import ConfigContext from '../../../contexts/configContext'
import TimedList from './timedList'
import SaleInformationModal from '../../../components/saleInformationModal'
import TimedSingle from './timedSingle'

import trackingEvents from '../../../constants/trackingEvents'
import { trackModal } from '../../../withTracking'

const {
  MODAL_AUCTION_TERMS,
  MODAL_SALE_INFO
} = trackingEvents

const DISBANDED_GROUP = 'Disbanded Group'

export class TimedDetails extends Component {
  static contextType = ConfigContext
  _registrationStatus = null
  _query = {}

  constructor () {
    super()
    this.state = {
      isSaleInfoModalVisible: false,
      isTermsModalVisible: false,
      supplementary: null
    }
  }

  _getAuctionUuid (listingUuid) {
    if (listingUuid) {
      return this.props.listings[listingUuid].auctionUuid
    }
    return this.props.isMarketplace ? 'marketplace' : this.props.uuid
  }

  handleToggleSaleInfoModal = () => {
    if (!this.state.isSaleInfoModalVisible) trackModal(MODAL_SALE_INFO)
    this.setState({
      isSaleInfoModalVisible: !this.state.isSaleInfoModalVisible
    })
  }

  handleToggleTermsModal = () => {
    if (!this.state.isTermsModalVisible) trackModal(MODAL_AUCTION_TERMS)
    this.setState({
      isTermsModalVisible: !this.state.isTermsModalVisible
    })
  }

  render () {
    const auctionUuid = this._getAuctionUuid()
    const auction = this.props.auctions[this.props.uuid]
    this._query = queryString.parse(this.props.location.search)

    // sale info
    const auctionInformation = auction && this.props.informations && this.props.informations[auctionUuid]
    const userUuid = this.props.userUuid

    const isShowingOpenOnly = this._query.open === 'true'
    let filterCategories = this._query.cat ? this._query.cat.split(',') : []
    const filterLocations = this._query.loc ? this._query.loc.split(',') : []
    const filterBidStatus = this._query.bstatus || ''
    const filterString = this._query.search || ''

    const filteredListingsByLosing = []
    const filteredListingsByWinning = []
    const filteredListingsByStarred = []

    const auctionHasEnded = auction.status === 'RECONCILIATION' || auction.status === 'ARCHIVED'
    let hasUpdatedCategories = false
    filterCategories.forEach(categoryUuid => {
      // check to see if category is actually a parent category
      const parentCategory = this.props.parentCategories[categoryUuid]
      if (parentCategory) {
        const indexOfCat = filterCategories.indexOf(categoryUuid)
        filterCategories.splice(indexOfCat, 1)
        // add the child categories to the category array
        filterCategories = filterCategories.concat(parentCategory.children)
        hasUpdatedCategories = true
      }
    })
    if (hasUpdatedCategories) {
      this._query.cat = filterCategories.join()
      const query = queryString.stringify(this._query)
      this.props.history.replace(`${this.props.match.url}?${query}`)
      return null
    }

    const lotIdentifierProperty = this.props.isMarketplace ? 'id' : 'lotNumber'
    const lotIdentifierModifier = this.props.isMarketplace ? 'toString' : 'toLowerCase'

    const filteredListings = auction.activeListings.filter(listingUuid => {
      const saleStatus = this.props.saleStatuses[listingUuid]
      const listing = this.props.listings[listingUuid]
      if (!listing || !saleStatus || (isShowingOpenOnly && saleStatus.complete)) return false
      if (filterLocations.length && !filterLocations.includes(listing.countryCode)) return false
      if (filterCategories.length && !filterCategories.includes(listing.categoryUuid)) return false
      if (listing.title === DISBANDED_GROUP) return false
      if (filterString) {
        const stringToLower = filterString.toLowerCase()
        return listing[lotIdentifierProperty][lotIdentifierModifier]().includes(stringToLower) ||
          listing.title.toLowerCase().includes(stringToLower) ||
          listing?.summary?.toLowerCase().includes(stringToLower) ||
          listing?.description?.toLowerCase().includes(stringToLower)
      }
      return true
    })

    filteredListings.forEach(listingUuid => {
      if (userUuid) {
        const saleStatus = this.props.saleStatuses[listingUuid]
        const sale = this.props.listingSales[listingUuid] || {}
        const offers = this.props.offers
        const bids = this.props.bids
        const favourites = this.props.favourites
        const userHasBid = !!sale.bids && !!sale.bids.filter(bidUuid => bids[bidUuid]?.userUuid === userUuid).length
        const highestBid = userHasBid && !!saleStatus.highestBidUuid && bids[saleStatus.highestBidUuid]
        const winningOffer = !!saleStatus.highestOfferUuid && offers && offers[saleStatus.highestOfferUuid]?.userUuid === userUuid
        const highestBidder = userHasBid && highestBid?.userUuid === userUuid && !saleStatus.highestOfferUuid
        const isHighestBidder = highestBidder || !!winningOffer
        const isStarred = userUuid && favourites[auctionUuid] && favourites[auctionUuid][listingUuid]
        if (isStarred) filteredListingsByStarred.push(listingUuid)
        if (isHighestBidder) filteredListingsByWinning.push(listingUuid)
        else if (userHasBid) filteredListingsByLosing.push(listingUuid)
      }
    })

    let visibleListings = filteredListings
    if (userUuid && filterBidStatus === 'w') visibleListings = filteredListingsByWinning
    if (userUuid && filterBidStatus === 'l') visibleListings = filteredListingsByLosing
    if (userUuid && filterBidStatus === 's') visibleListings = filteredListingsByStarred

    // Sale information model values derived from the auction or the current listing if single item view
    const listingUuid = this.props.match.params.listingUuid

    const hasStarted = (this.props.isInteractive && this.props.hasStarted) || auction.webcast

    return (
      <section aria-label='Timed Auction View'>
        <Switch>
          <Route exact path={['/auctions/:auctionUuid', '/marketplace']}>
            <TimedList
              hasStarted={hasStarted}
              auctionHasEnded={auctionHasEnded}
              isMarketplace={this.props.isMarketplace}
              listingUuidCountLosing={filteredListingsByLosing.length}
              listingUuidCountStarred={filteredListingsByStarred.length}
              listingUuidCountWinning={filteredListingsByWinning.length}
              listingUuids={visibleListings}
              onToggleTermsModal={this.handleToggleTermsModal}
              onToggleSaleInformationModal={this.handleToggleSaleInfoModal}
              uuid={this.props.uuid}
            />
          </Route>
          <Route
            path={['/auctions/:auctionUuid/listings/:listingUuid', '/marketplace/listings/:listingUuid']}
            render={() => (
              <TimedSingle
                hasStarted={hasStarted}
                auctionHasEnded={auctionHasEnded}
                isMarketplace={this.props.isMarketplace}
                listingUuid={listingUuid}
                listingUuids={visibleListings}
                onToggleTermsModal={this.handleToggleTermsModal}
                onToggleSaleInformationModal={this.handleToggleSaleInfoModal}
                uuid={this.props.uuid}
              />
            )}
          />
        </Switch>
        <SaleInformationModal
          auctionUuid={auctionUuid}
          isMarketplace={this.props.isMarketplace}
          listingUuid={listingUuid}
          isOpen={this.state.isSaleInfoModalVisible}
          onClose={this.handleToggleSaleInfoModal}
        />
        <Modal size='lg' onClose={this.handleToggleTermsModal} isOpen={this.state.isTermsModalVisible} id='termsModal'>
          <ModalHeader onClose={this.handleToggleTermsModal}>
            {translate('JspPublicCodes_JSP_AUCTION_INFORMATION_TS_AND_CS')}
          </ModalHeader>
          <ModalBody>
            <h2 className='modal__primary-title h3' id='termsModal__title'>{auction.title}</h2>
            <div
              id='termsModal__content' dangerouslySetInnerHTML={{
                __html: auctionInformation?.termsAndConditionsInformation
              }}
            />
          </ModalBody>
        </Modal>
      </section>
    )
  }
}

TimedDetails.propTypes = {
  auctions: PropTypes.object.isRequired,
  bids: PropTypes.object.isRequired,
  favourites: PropTypes.object.isRequired,
  hasStarted: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired
  }).isRequired,
  informations: PropTypes.object.isRequired,
  isInteractive: PropTypes.bool.isRequired,
  isMarketplace: PropTypes.bool.isRequired,
  listings: PropTypes.object.isRequired,
  listingSales: PropTypes.object.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      listingUuid: PropTypes.string
    }),
    url: PropTypes.string.isRequired
  }),
  offers: PropTypes.object.isRequired,
  parentCategories: PropTypes.object.isRequired,
  saleStatuses: PropTypes.object.isRequired,
  userUuid: PropTypes.string,
  uuid: PropTypes.string
}

TimedDetails.defaultProps = {
  isInteractive: false
}

export function mapStateToProps (state) {
  return {
    auctions: state.auctions.auctions,
    bids: state.bids.bids,
    favourites: state.lots.favourites,
    informations: state.auctions.information,
    listings: state.lots.listings,
    listingSales: state.listingSales.sales,
    parentCategories: state.categories.categoryParents,
    offers: state.offers.offers,
    saleStatuses: state.saleStatuses.saleStatuses,
    userUuid: state.users.user.uuid
  }
}

export default withRouter(connect(mapStateToProps, {})(TimedDetails))
